<template>
  <v-app id="inspire">
    <v-col cols="12">
      <router-link to="/" style="text-decoration: none" title="Back">
        <v-btn
          color="warning"
          fab
          small
          dark
          style="float: left; margin-left: 5px"
        >
          <v-icon class="fa fa-arrow-left"></v-icon>
        </v-btn>
      </router-link>
      <h1>You're not enough authorized to access this function</h1>
      <div class="background"></div>
      <img src="https://www.rachnasagar.in/images/home/Stop-Logo.png" />
      <!-- <img src="https://i.pinimg.com/originals/70/0e/d1/700ed10164809b178db74c3c38654e30.png"> -->
    </v-col>
  </v-app>
</template>

<script>
import { Auth } from "aws-amplify";
export default {
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>